import ServiceBase from '@ekd/portal-connector/dist/Service';
import { ApiUrls } from '@root/common/types/apiUrls';
import { getEnv } from '@root/common/utils/getEnv';

import { Subscription } from '@paywall/types';

export function createCheckAdFreeService({ service }: { service: ServiceBase<ApiUrls> }) {
  return {
    async checkAdFree(token: string | null) {
      if (!token) {
        return null;
      }

      const jwtParse = JSON.parse(atob(token.split('.')[1]));
      const id = jwtParse.cid;

      try {
        let isAdfree = false;
        const apiProvider = service.createProvider('HTTP');
        const headers = { Authorization: `Bearer ${token}` };
        const data = await apiProvider.request<Subscription[]>({ url: `${getEnv('ordersApi')}/user/${id}/service-info`, headers, method: 'get' });

        data.forEach((subscription: Subscription) => {
          if (subscription.valid && subscription.service.id === 2) {
            isAdfree = true;
          }
        });

        return isAdfree;
      } catch (error) {
        return null;
      }
    },
  };
}
